import React from 'react';
import PropTypes from 'prop-types';

import {
  fulfillmentOptions,
  ALL_FULFILLMENT_METHODS
} from 'constants/fulfillmentOptions';
import HeroHeading from 'bento-ordering/base/ui_components/HeroHeading';

function FulfillmentMethodAvailabilityHeader({
  availableFulfillmentMethods,
  hasHeroImage
}) {
  const getHeadingLabel = () => {
    if (
      availableFulfillmentMethods.includes(fulfillmentOptions.PICKUP) &&
      availableFulfillmentMethods.includes(fulfillmentOptions.DELIVERY)
    ) {
      return 'Order for delivery or pickup';
    }

    return `Order for ${availableFulfillmentMethods[0]}`;
  };

  return (
    <HeroHeading hasHeroImage={hasHeroImage}>{getHeadingLabel()}</HeroHeading>
  );
}

FulfillmentMethodAvailabilityHeader.propTypes = {
  availableFulfillmentMethods: PropTypes.arrayOf(
    PropTypes.oneOf(ALL_FULFILLMENT_METHODS)
  ),
  hasHeroImage: PropTypes.bool
};

export default FulfillmentMethodAvailabilityHeader;
